import { request } from './request';

export const getAllCalendlyEvents = () => request('calendly_events');
